module.exports = __webpack_public_path__ + "img/payment-paypal@2x.20b68857.png";